import {
  TaxCouponPaymentType,
  TaxCouponPaymentTypeLabel,
} from '@/core/domain/coupon/coupons/coupons.types';
import { Select, SelectProps } from 'antd';

const paymentMethodOptions = [
  { value: TaxCouponPaymentType.CASH, label: TaxCouponPaymentTypeLabel.CASH },
  { value: TaxCouponPaymentType.CHECK, label: TaxCouponPaymentTypeLabel.CHECK },
  {
    value: TaxCouponPaymentType.CREDIT_CARD,
    label: TaxCouponPaymentTypeLabel.CREDIT_CARD,
  },
  {
    value: TaxCouponPaymentType.DEBIT_CARD,
    label: TaxCouponPaymentTypeLabel.DEBIT_CARD,
  },
  {
    value: TaxCouponPaymentType.STORE_CREDIT,
    label: TaxCouponPaymentTypeLabel.STORE_CREDIT,
  },
  {
    value: TaxCouponPaymentType.FOOD_VOUCHER,
    label: TaxCouponPaymentTypeLabel.FOOD_VOUCHER,
  },
  {
    value: TaxCouponPaymentType.MEAL_VOUCHER,
    label: TaxCouponPaymentTypeLabel.MEAL_VOUCHER,
  },
  {
    value: TaxCouponPaymentType.GIFT_VOUCHER,
    label: TaxCouponPaymentTypeLabel.GIFT_VOUCHER,
  },
  {
    value: TaxCouponPaymentType.GAS_VOUCHER,
    label: TaxCouponPaymentTypeLabel.GAS_VOUCHER,
  },
  {
    value: TaxCouponPaymentType.TRADE_DUPLICATES,
    label: TaxCouponPaymentTypeLabel.TRADE_DUPLICATES,
  },
  {
    value: TaxCouponPaymentType.BANK_SLIP,
    label: TaxCouponPaymentTypeLabel.BANK_SLIP,
  },
  {
    value: TaxCouponPaymentType.BANK_DEPOSIT,
    label: TaxCouponPaymentTypeLabel.BANK_DEPOSIT,
  },
  {
    value: TaxCouponPaymentType.BANK_INSTANT_TRANSFER,
    label: TaxCouponPaymentTypeLabel.BANK_INSTANT_TRANSFER,
  },
  {
    value: TaxCouponPaymentType.BANK_TRANSFER,
    label: TaxCouponPaymentTypeLabel.BANK_TRANSFER,
  },
  {
    value: TaxCouponPaymentType.CASHBACK_CREDIT,
    label: TaxCouponPaymentTypeLabel.CASHBACK_CREDIT,
  },
  {
    value: TaxCouponPaymentType.MULTI_ISSUER_CREDIT_CARD,
    label: TaxCouponPaymentTypeLabel.MULTI_ISSUER_CREDIT_CARD,
  },
  {
    value: TaxCouponPaymentType.NO_PAYMENT,
    label: TaxCouponPaymentTypeLabel.NO_PAYMENT,
  },
  {
    value: TaxCouponPaymentType.OTHERS,
    label: TaxCouponPaymentTypeLabel.OTHERS,
  },
];

const CouponPaymentMethodSelect: React.FC<Omit<SelectProps, 'options'>> = (
  props,
) => {
  return <Select {...props} options={paymentMethodOptions} />;
};

export default CouponPaymentMethodSelect;
